import comp from "./AIPanelContextBarAttachment";
export default comp;
